export default "__VITE_ASSET__CS7AG88B__"